import { Graphics } from "pixi.js";
import type { Point } from "./geometry";
import type { NavigationState } from "./navigation-types";

export class AutopilotOverlay {
  readonly container = new Graphics();

  render(state: NavigationState, position: Point, zoom: number): void {
    const view = this.container.clear();
    if (state.status === "idle") return;
    const color = state.status === "blocked" ? 0xdb8d79 : 0xf1c77d;
    if (state.status === "flying") {
      view.moveTo(position.x, position.y);
      for (const point of state.path) view.lineTo(point.x, point.y);
      view.stroke({ color, width: 1.2 / zoom, alpha: 0.45 });
    }
    view
      .circle(state.destination.x, state.destination.y, 9 / zoom)
      .stroke({ color, width: 1.4 / zoom, alpha: 0.9 });
    view
      .moveTo(state.destination.x - 14 / zoom, state.destination.y)
      .lineTo(state.destination.x - 6 / zoom, state.destination.y)
      .moveTo(state.destination.x + 6 / zoom, state.destination.y)
      .lineTo(state.destination.x + 14 / zoom, state.destination.y)
      .moveTo(state.destination.x, state.destination.y - 14 / zoom)
      .lineTo(state.destination.x, state.destination.y - 6 / zoom)
      .moveTo(state.destination.x, state.destination.y + 6 / zoom)
      .lineTo(state.destination.x, state.destination.y + 14 / zoom)
      .stroke({ color, width: 1 / zoom, alpha: 0.65 });
  }
}
